import { render, staticRenderFns } from "./form-create-board.vue?vue&type=template&id=64228730&scoped=true&"
import script from "./form-create-board.vue?vue&type=script&lang=ts&"
export * from "./form-create-board.vue?vue&type=script&lang=ts&"
import style0 from "./form-create-board.vue?vue&type=style&index=0&id=64228730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64228730",
  null
  
)

export default component.exports